import React, { memo } from "react";
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import { TextFieldWithLabel } from "../components/TextField";
import { MAX_LENGTH_CONSTRAINTS } from "../constants";
import FormSectionHeader from "../common/FormSectionHeader";
import { isVoidPickupMode } from "../utils";

const BillingForm = ({ billingInfo, updateFormData, classes, mode }) => {
  const handleChange = (name) => (value) => {
    const billingData = {
      ...billingInfo,
      [name]: value,
    };
    updateFormData("billingInfo", billingData);
  };
  const isReadOnly = isVoidPickupMode(mode);

  return (
    <>
      <FormSectionHeader label="Billing Info" />
      <div className={classes.container} id="billingInfo">
        <TextFieldWithLabel
          label="Bill To Code :"
          id="billToCode"
          handleChange={handleChange("billToCode")}
          value={billingInfo.billToCode}
          className={classes.defaultInput}
          containerClass={classes.fieldContainer}
          labelClass={classes.label}
          inputClass={classes.input}
          inputProps={{
            maxLength: MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.BILL_TO_CODE,
          }}
          isReadOnly={isReadOnly}
        />
        <TextFieldWithLabel
          label="Bill To Name :"
          id="billToName"
          handleChange={handleChange("billToName")}
          value={billingInfo.billToName}
          labelClass={classes.label}
          inputClass={classes.input}
          containerClass={classes.namefieldContainer}
          className={classes.defaultInput}
          inputProps={{
            maxLength: MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.BILL_TO_NAME,
          }}
          isReadOnly={isReadOnly}
        />
        <TextFieldWithLabel
          label="Reference # :"
          id="reference"
          handleChange={handleChange("referenceNumber")}
          value={billingInfo.referenceNumber}
          labelClass={classes.label}
          inputClass={classes.input}
          containerClass={classes.fieldContainer}
          className={classes.defaultInput}
          inputProps={{
            maxLength:
              MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.REFERENCE_NUMBER,
          }}
          isReadOnly={isReadOnly}
        />
        <TextFieldWithLabel
          label="Quote # :"
          id="quote"
          handleChange={handleChange("quoteNumber")}
          value={billingInfo.quoteNumber}
          labelClass={classes.label}
          inputClass={classes.input}
          containerClass={classes.fieldContainer}
          className={classes.defaultInput}
          inputProps={{
            maxLength: MAX_LENGTH_CONSTRAINTS.CREATE_PICKUP_FORM.QUOTE_NUMBER,
          }}
          isReadOnly={isReadOnly}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(memo(BillingForm));
